export default "__VITE_ASSET__BE2n6Rp___"